import React, { useEffect } from "react";
import "./style.scss";
import { AiFillCheckCircle } from "react-icons/ai";
import useTypeSale from "../../../utils/hooks/useTypeSale";
import { useLocation, useNavigate } from "react-router";
import { EXERCISE_PAGE, FINALIZE_PAGE, PASS_PAGE, REALIZE_VOUCHER_PAGE, TICKETS_PAGE, ZONES_PAGE } from "../../routes";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { scrollPageTo } from "../../animations/scrollPageTo";
import { PASS_SALE, REALIZE_VOUCHER } from "../../models/TypeSale";

interface IProps {
  children: any;
}

const Navigation: React.FC<IProps> = ({ children }: IProps) => {
  const { isSaleWithExercise, typeSale } = useTypeSale();
  const location = useLocation();
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();

  const isPassSale = location.pathname === PASS_PAGE || typeSale === PASS_SALE;
  const isRealizeVoucher = location.pathname === REALIZE_VOUCHER_PAGE || typeSale === REALIZE_VOUCHER;
  const isStepTwo =
    location.pathname === TICKETS_PAGE || location.pathname === PASS_PAGE || location.pathname === REALIZE_VOUCHER_PAGE;
  const isStepSelectExercise = location.pathname === EXERCISE_PAGE;
  const finalizeStep = location.pathname === FINALIZE_PAGE;
  const stepTwoText = () => {
    if (isPassSale) {
      return "Wybierz voucher";
    }
    if (isRealizeVoucher) {
      return "Wykorzystaj voucher";
    }
    return "Wybierz bilet";
  };

  const navigateStepTwo = () => {
    if (isPassSale) {
      return navigate(`${PASS_PAGE}`);
    }
    if (isRealizeVoucher) {
      return navigate(`${REALIZE_VOUCHER_PAGE}?isSaleWithExercise=true`);
    }
    return navigate(`${TICKETS_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
  };

  useEffect(() => {
    window.parent.postMessage("scroll::", "*");
    window.parent.postMessage("resize::1500", "*");
    scrollPageTo(0);
  }, []);

  return (
    <React.Fragment>
      <div className={"navigation-panel"} id={"navigation"}>
        <div className={"navi-wrapper"}>
          <div className={"navi-element"} onClick={() => navigate(ZONES_PAGE)}>
            <AiFillCheckCircle className={"icon-check nav-disabled-prev"} />
            {isDesktop && <p className={"nav-disabled-prev"}>Wybierz strefę</p>}
          </div>
          <p className={"navi-divider"} />
          <div className={"navi-element"} onClick={() => navigateStepTwo()}>
            {isStepTwo ? (
              <div className={"nav-number-select"}>2</div>
            ) : (
              <AiFillCheckCircle className={"icon-check nav-disabled-prev"} />
            )}
            {isDesktop && <p className={`${isStepTwo ? "" : "nav-disabled-prev"}`}>{stepTwoText()}</p>}
          </div>
          <p className={"navi-divider"} />
          {isSaleWithExercise && (
            <>
              <div
                className={"navi-element"}
                onClick={() => navigate(`${TICKETS_PAGE}?isSaleWithExercise=${isSaleWithExercise}`)}
              >
                {isStepSelectExercise ? (
                  <>
                    <div className={"nav-number-select"}>3</div>
                    {isDesktop && <p>Wybierz dzień</p>}
                  </>
                ) : finalizeStep ? (
                  <>
                    <AiFillCheckCircle className={"icon-check nav-disabled-prev"} />
                    {isDesktop && <p className={"nav-disabled-prev"}>Wybierz dzień</p>}
                  </>
                ) : (
                  <>
                    <div className={"nav-number"}>3</div>
                    {isDesktop && <p className={"nav-disabled-next"}>Wybierz dzień</p>}
                  </>
                )}
              </div>
              <p className={"navi-divider"} />
            </>
          )}
          <div className={"navi-element"}>
            <div className={finalizeStep ? "nav-number-select" : "nav-number"}>{isSaleWithExercise ? "4" : "3"}</div>
            {isDesktop && <p className={finalizeStep ? "" : "nav-disabled-next"}>Podsumowanie</p>}
          </div>
        </div>
      </div>
      {children}
    </React.Fragment>
  );
};

export default Navigation;
